import React from 'react';
import {Dialog, DialogContent, DialogTitle, IconButton} from "@mui/material";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from "@mui/material/useMediaQuery";
import clsx from "clsx";

const SimpleDialog = ({
	                      open,
	                      handleClose,
	                      title,
	                      subtitle,
	                      content,
	                      actions,
	                      maxWidth = "sm",
	                      fullWidht = true,
	                      customFullScreen = false,
	                      paperCalss,
	                      paperClassName,
	                      contentClassName,
	                      closeOnBackdropClick = false,
	                      showCloseButton = false
                      }) => {
	const classes = BaseStyle();
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const resolvedPaperClassName = clsx(classes.dialogPaper, title && classes.dialogPaperWithTitle, paperCalss, paperClassName);
	const resolvedContentClassName = clsx(
		classes.dialogContent,
		title && (subtitle ? classes.dialogContentWithSubtitle : classes.dialogContentWithTitle),
		contentClassName
	);
	const onDialogClose = (event, reason) => {
		if (reason === "backdropClick" && !closeOnBackdropClick) {
			return;
		}
		handleClose?.(event, reason);
	};
	
	return (
		<React.Fragment>
			<Dialog
				maxWidth={maxWidth}
				fullScreen={customFullScreen ? fullScreen : customFullScreen}
				fullWidth={fullWidht}
				PaperProps={{
					className: resolvedPaperClassName
				}}
				slotProps={{
					paper: {
						className: resolvedPaperClassName
					}
				}}
				scroll="paper"
				open={open}
				onClose={onDialogClose}
			>
				{title && (
					<DialogTitle className={classes.dialogTitle}>
						<span className={classes.dialogTitleCopy}>
							<span className={classes.dialogTitleText}><b>{title}</b></span>
							{subtitle && <span className={classes.dialogSubtitle}>{subtitle}</span>}
						</span>
						{showCloseButton && (
							<IconButton
								aria-label="Chiudi dialog"
								className={classes.dialogCloseButton}
								onClick={() => handleClose?.()}
								size="small"
							>
								<CloseTwoToneIcon fontSize="small"/>
							</IconButton>
						)}
					</DialogTitle>
				)}
				<DialogContent className={resolvedContentClassName}>
					{content}
				</DialogContent>
				{
					actions && actions
				}
			</Dialog>
		</React.Fragment>
	);
};

export default React.memo(SimpleDialog);
